import React from 'react';
import Link from '@/links';
import Facebook from '@/svg/social-icons/facebook';
import Twitter from '@/svg/social-icons/twitter';
import Youtube from '@/svg/social-icons/youtube';
import LinkedIn from '@/svg/social-icons/linkedin';
import Instagram from '@/svg/social-icons/instagram';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './footer.module.scss';

export const SocialVariants = {
  LIGHT: 'light',
  DARK: 'dark'
};

const propTypes = {
  variant: PropTypes.oneOf([SocialVariants.LIGHT, SocialVariants.DARK])
};

const Social = ({variant = SocialVariants.LIGHT}) => (
  <ul className={classNames(styles['list-inline'], styles['social-list'])}>
    <li>
      <Link
        href="//www.linkedin.com/company/workable-software"
        target="_blank"
        rel="noopener"
        title="Workable on LinkedIn">
        <div
          className={classNames(styles['social-icon'], {
            [styles['social-icon--dark']]: variant === SocialVariants.DARK
          })}>
          {' '}
          <LinkedIn />{' '}
        </div>
      </Link>
    </li>
    <li>
      <Link href="//www.facebook.com/workable" target="_blank" title="Workable on Facebook">
        <div
          className={classNames(styles['social-icon'], {
            [styles['social-icon--dark']]: variant === SocialVariants.DARK
          })}>
          <Facebook />
        </div>
      </Link>
    </li>
    <li>
      <Link href="https://x.com/workable" target="_blank" rel="noopener" title="Workable on X">
        <div
          className={classNames(styles['social-icon'], {
            [styles['social-icon--dark']]: variant === SocialVariants.DARK
          })}>
          <Twitter />
        </div>
      </Link>
    </li>
    <li>
      <Link
        href="//www.instagram.com/workable/"
        target="_blank"
        rel="noopener"
        title="Workable on Instagram">
        <div
          className={classNames(styles['social-icon'], {
            [styles['social-icon--dark']]: variant === SocialVariants.DARK
          })}>
          <Instagram />
        </div>
      </Link>
    </li>
    <li>
      <Link
        href="//www.youtube.com/@WorkableSoftware"
        target="_blank"
        rel="noopener"
        title="Workable on Youtube">
        <div
          className={classNames(styles['social-icon'], {
            [styles['social-icon--dark']]: variant === SocialVariants.DARK
          })}>
          <Youtube />
        </div>
      </Link>
    </li>
  </ul>
);

Social.propTypes = propTypes;

export default Social;
